import { jsx as _jsx } from "react/jsx-runtime";
import { TextDisplayPanel } from '../TextDisplayPanel/index.js';
/**
 * 原文展示UI组件
 */
export const OriginalTextView = ({ paragraphs, sourceLanguage: _sourceLanguage, currentParagraph, onParagraphMouseUp, onParagraphTouchEnd, renderParagraphContent, virtualizer, }) => {
    // 将数据转换为TextDisplayPanel需要的格式
    const displayParagraphs = paragraphs.map(paragraph => ({
        id: paragraph.id,
        text: paragraph.content,
        isHighlighted: currentParagraph?.id === paragraph.id,
        onMouseUp: (e) => {
            onParagraphMouseUp?.(e, paragraph);
        },
        onTouchEnd: (e) => {
            onParagraphTouchEnd?.(e, paragraph);
        },
        // 如果有自定义渲染函数，使用它
        children: renderParagraphContent ? renderParagraphContent(paragraph) : paragraph.content,
    }));
    // 使用TextDisplayPanel渲染UI
    return (_jsx(TextDisplayPanel, { title: "", paragraphs: displayParagraphs, fallbackText: undefined, virtualizer: virtualizer }));
};
export default OriginalTextView;
//# sourceMappingURL=OriginalTextView.js.map